// Money is always integer cents. Parsing never goes through floating point.

const formatters = new Map<string, Intl.NumberFormat>();

export function formatCents(cents: number, locale = 'fi-FI', currency = 'EUR'): string {
  const key = `${locale}:${currency}`;
  let formatter = formatters.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formatters.set(key, formatter);
  }
  // Integer cents / 100 is exactly representable to two decimals for all realistic amounts.
  return formatter.format(cents / 100);
}

/** Parses user input such as "5", "5,5", "5,50", "1 234,00" or "5.50" into cents. */
export function parseEuroInput(input: string): number | null {
  const cleaned = input.replace(/[\s €]/g, '').replace(',', '.');
  const match = /^(\d{1,7})(?:\.(\d{1,2}))?$/.exec(cleaned);
  if (!match) return null;
  const euros = Number(match[1]);
  const fraction = (match[2] ?? '').padEnd(2, '0');
  return euros * 100 + Number(fraction);
}

export function centsToInput(cents: number): string {
  const euros = Math.floor(cents / 100);
  const rest = cents % 100;
  return rest === 0 ? String(euros) : `${euros},${String(rest).padStart(2, '0')}`;
}
